import { centerable as m } from "../decorators/centerable.js";
import { uploadable as n } from "../decorators/uploadable.js";
import { BLOCK_CLASSES as i } from "../../constants.js";
import "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const e = {
  element: i.imageText,
  image: `${i.imageText}-image`,
  imageContainer: `${i.imageText}-image-container`,
  description: `${i.imageText}-description`,
  textContainer: `${i.imageText}-text-container`,
  title: `${i.imageText}-title`
}, x = m(
  n({
    inline: !1,
    attrs: {
      type: { default: "imageText" },
      imageUrl: { default: "" },
      text: { default: "" },
      title: { default: "" }
    },
    group: "block",
    parseDOM: [
      {
        tag: e.element,
        getAttrs(t) {
          let l = t.querySelector(`.${e.image}`), a = t.querySelector(`.${e.title}`), r = t.querySelector(`.${e.description}`);
          return {
            imageUrl: l.getAttribute("src"),
            title: a.textContent,
            text: r.textContent
          };
        }
      }
    ],
    toDOM(t) {
      let { imageUrl: l, text: a, title: r } = t.attrs;
      return [
        "div",
        {
          class: e.element,
          "data-type": "imageText"
        },
        [
          "div",
          {
            class: e.imageContainer
          },
          [
            "img",
            {
              src: l,
              alt: a,
              class: e.image
            }
          ]
        ],
        [
          "div",
          {
            class: e.textContainer
          },
          [
            "div",
            {
              class: e.title
            },
            ["b", {}, r]
          ],
          [
            "div",
            {
              class: e.description
            },
            a
          ]
        ]
      ];
    }
  })
);
function p(t) {
  t.querySelectorAll(`.${i.imageText}`).forEach((a) => {
    a.remove();
  });
}
export {
  p as cleanImageTextFromElement,
  e as imageTextCssClasses,
  x as imageTextSpec
};
